import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["width", "height"];
const _hoisted_2 = ["r", "stroke", "stroke-width"];
import { computed } from "vue";
export default /*#__PURE__*/ _defineComponent({
    props: {
        size: {
            type: Number,
            default: null,
        },
        color: {
            type: String,
            default: "#000000",
        },
        stroke: {
            type: Number,
            default: 5,
        },
    },
    setup(__props) {
        const props = __props;
        const pxSize = computed(() => {
            if (props.size === null) {
                return "auto";
            }
            return props.size + "px";
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("svg", {
                class: "circular-spinner",
                width: _unref(pxSize),
                height: _unref(pxSize),
                viewBox: "-50 -50 100 100"
            }, [
                _createElementVNode("circle", {
                    r: 50 - props.stroke,
                    fill: "none",
                    stroke: props.color,
                    "stroke-width": __props.stroke,
                    pathLength: "150"
                }, null, 8 /* PROPS */, _hoisted_2)
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
